import React, { useState, useEffect } from 'react';
import '../../../App.css'
import { postAPI } from '../../../app/api';
import SearchAlumniDirectory from '../Alumni/SearchAlumniDirectory';
import clubImg from "../../../assets/img/club-img.png";

const { REACT_APP_BRANDURL } = process.env;

// HTML Assets Base URL
const HTML_ASSETS_URL = 'https://retechprime.com/be-college-ex-students-club/html/';

export default function HeroBanner() {
    const [heroData, setHeroData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchHeroData();
    }, []);

    const fetchHeroData = async () => {
        try {
            setLoading(true);
            const response = await postAPI('hero-data/fetchData/home', {});

            if (response?.status === 1 && response?.data) {
                const data = response.data;

                // Normalize the data to handle both old and new database structures
                const normalizedData = {
                    ...data,
                    // Fallback: If backgroundImage is empty, use the old 'image' field
                    backgroundImage: data.backgroundImage || data.image || '',
                    mainImage: data.mainImage || '',
                    badgeImage: data.badgeImage || '',
                    overlayColor: data.overlayColor || 'rgba(0, 51, 153, 0.6)',
                    titleSize: data.titleSize || '48px',
                    descriptionSize: data.descriptionSize || '18px'
                };

                console.log('✅ Hero data normalized:', normalizedData);
                setHeroData(normalizedData);
            } else {
                console.warn('⚠️ No hero data found, using fallback banner');
                setHeroData(null);
            }
        } catch (error) {
            console.error('❌ Error fetching hero data:', error);
            setHeroData(null);
        } finally {
            setLoading(false);
        }
    };
    // Fallback banner component
    const FallbackBanner = () => (
        <section className="home-banner">
            <div className="container-xxl container-xl container-fluid">
                <div className="row align-items-center justify-content-between">
                    <div className="col-lg-6 col-md-6 text-lg-start text-md-start text-center mb-lg-0 mb-md-0 mb-5">
                        <h1><span>BE College</span> Ex-Students' Club - Celebrating the Spirit of <span>Alumni</span></h1>
                        <p>Built on friendship and shared purpose, the club connects generations of BE College graduates through culture, service, and memories.</p>
                        <div className="mt-5">
                            <a href="/registration" className="btn btn-secondary me-3 66">
                                <img src={`${REACT_APP_BRANDURL}theme/assets/images/icon/member-icon.svg`} alt="Register" />
                                Register as member
                            </a>
                            <a href="/about" className="btn btn-white">
                                <img src={`${REACT_APP_BRANDURL}theme/assets/images/icon/info-icon.svg`} alt="Info" />
                                More info
                            </a>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-5 banner-slider">
                        <div className="swiper banner-action">
                            <div className="swiper-wrapper">
                                <div className="swiper-slide">
                                    <figure><img src={`${REACT_APP_BRANDURL}theme/assets/images/home/banner-01.png`} className="img-fluid" alt="Banner 1" /></figure>
                                </div>
                                <div className="swiper-slide">
                                    <figure><img src={`${REACT_APP_BRANDURL}theme/assets/images/home/banner-02.png`} className="img-fluid" alt="Banner 2" /></figure>
                                </div>
                            </div>
                        </div>
                        <img src={`${REACT_APP_BRANDURL}theme/assets/images/home/be-college-shild.png`} className="establishment" alt="BE College Shield" />
                    </div>
                </div>
            </div>
        </section>
    );

    // Dynamic hero banner component - only background image is dynamic
    const DynamicBanner = ({ data }) => {
        // API URL for uploaded images
        const API_BASE_URL = process.env.REACT_APP_APIURL || 'https://beapi.shikshaprime.com/';

        const getImgUrl = (path) => {
            if (!path) return '';
            // If it's already a full URL (http...), return it, otherwise prefix with API URL
            return path.startsWith('http') ? path : `${API_BASE_URL}${path.startsWith('/') ? path.slice(1) : path}`;
        }

        return (
            <section
                className="home-banner"
                style={{
                    backgroundImage: `url(${getImgUrl(data?.backgroundImage)})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }}
            >
                <div className="container-xxl container-xl container-fluid">
                    <div className="row align-items-center justify-content-between">
                        <div className="col-lg-6 col-md-6 text-lg-start text-md-start text-center mb-lg-0 mb-md-0 mb-5">
                            <h1><span>B E College</span> Ex-Students' Club - Celebrating the Spirit of <span>Alumni</span></h1>
                            <p>Built on friendship and shared purpose, the club connects generations of B E College graduates through culture, service, and memories.</p>
                            <div className="mt-5">
                                <a href="/registration" className="btn btn-secondary me-3">
                                    <img src={`${REACT_APP_BRANDURL}theme/assets/images/icon/member-icon.svg`} alt="Member" />
                                    New member
                                </a>
                                <a href="/about" className="btn btn-white">
                                    <img src={`${REACT_APP_BRANDURL}theme/assets/images/icon/info-icon.svg`} alt="Info" />
                                    More info
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-5 banner-slider">
                            <figure className='club-img'>
                                <img src={`${HTML_ASSETS_URL}assets/images/home/banner-01.png`} alt="BE College Shield" />
                            </figure>
                            <figure className="college-img">
                                <img src={clubImg} alt="Club Image" />
                            </figure>
                        </div>
                    </div>
                </div>
            </section>
        );
    };

    return (
        <>
            {loading ? (
                <FallbackBanner />
            ) : heroData ? (
                <DynamicBanner data={heroData} />
            ) : (
                <FallbackBanner />
            )}
            <SearchAlumniDirectory />
        </>
    );
}
